import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { sub1_act2_Financieros, sub1_act2_NetoOxxo, sub1_act2_SolicitaInformacion, sub1_act2_Solicitaidentificacion, sub1_act2_VentaResponsable, sub1_act2_ChicaOxxo1, sub1_act2_ChicoOxxo2, sub1_act2_ChicoOxxo3 } from "../../../assets/tema7";
import { voicesTypeControl } from '../../../types/audioType';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	win: 12
};


const infoArray = [
	{
		id: 1,
		title: " Menores de edad",
		img: sub1_act2_VentaResponsable
	},
	{
		id: 2,
		title: "Infórmate",
		img: sub1_act2_SolicitaInformacion
	},
	{
		id: 3,
		title: "Solicita una identificación",
		img: sub1_act2_Solicitaidentificacion
	},
	{
		id: 4,
		title: "Horarios",
		img: sub1_act2_Financieros
	},
]

const infoDoblePerson = [
	{
		id: 1,
		p1: {
			title: "¿Cuándo?",
			img: sub1_act2_ChicaOxxo1,
			subtitle: "La persona busca comprar alcohol fuera de horario de venta según tu ciudad o municipio."
		},
		p2: {
			title: "¿Cómo?",
			img: sub1_act2_NetoOxxo,
			subtitle: "Infórmale sobre los horarios permitidos de venta de alcohol"
		}
	},
	{
		id: 2,
		p1: {
			title: "¿Cuándo?",
			img: sub1_act2_ChicoOxxo2,
			subtitle: "El cliente es menor de edad y quiere comprar cigarros o alcohol."
		},
		p2: {
			title: "¿Cómo?",
			img: sub1_act2_NetoOxxo,
			subtitle: "Menciona que esta prohibido la venta a menores debido a políticas legales y de la empresa."
		}
	},
	{
		id: 3,
		p1: {
			title: "¿Cuándo?",
			img: sub1_act2_ChicoOxxo3,
			subtitle: "El cliente aparenta ser menor de edad y quiere comprar cigarros."
		},
		p2: {
			title: "¿Cómo?",
			img: sub1_act2_NetoOxxo,
			subtitle: `Solicita una identificación que acredita su mayoría de edad (INE, por ejemplo).`
		}
	},
]

export const Theme7SubtopicOneActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema7.activities.subtema1], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 7 sub 1 act 2");
			ObserverEmitter.emit(EVENTS.tema7.topic1.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a08)
	})

	const [numberInfoClient, setNumberInfoClient] = useState(0)
	const [numberInfoDoubleClient, setNumberInfoDoubleClient] = useState(0)

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema7.topic1.initScene, 2);
						setNumberInfoClient(0)
						setNumberInfoDoubleClient(0)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 2: Directrices legales.' />
					<DialogBarNew
						dialog={`Las ventas responsables implican tener cuidado a quién le vendes (alcohol, cigarrillos) y a qué hora lo haces.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1. Venta Responsable"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a09)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Debes conocer las leyes de tu ciudad o municipio, pero es importante que siempre recuerdes éstas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a10)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{[
				steps.dialogThree,
				steps.dialogFour,
				steps.dialogFive,
				steps.dialogSix,
			].includes(uiToShow) && (
					<>
						<div className='h-full w-full fixed z-40 bg-[#00000074] flex justify-center items-center'>
							<div className="w-[176px] h-[220px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
								<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
									<p className="text-white text-[10px] md:text-[16px]">{infoArray[numberInfoClient].title}</p>
								</div>
								<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
									<div className="w-full h-full py-3">
										<img className="h-full w-full object-contain" src={infoArray[numberInfoClient].img} alt="client" />
									</div>
								</div>
							</div>
						</div>
					</>
				)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`No vendas alcohol o cigarros a menores de edad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a11)
							setNumberInfoClient(1)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Investiga con las autoridades correspondientes sobre las sanciones por la venta de alcohol y cigarros.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a12)
							setNumberInfoClient(2)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Solicita que la credencial sea vigente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a13)
							setNumberInfoClient(3)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Respeta los horarios de venta permitidos en tu ciudad o municipio.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad2.sub1a14)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Conociendo las leyes sabrás como y cuando negar una venta de alcohol, por ejemplo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{[
				steps.dialogEight,
				steps.dialogNine,
				steps.dialogTen,
			].includes(uiToShow) && (
					<>
						<div className='h-full w-full fixed z-40 bg-[#00000074] flex justify-center items-center'>
							<div className='flex gap-4'>
								<CardDoubleInfo {...infoDoblePerson[numberInfoDoubleClient].p1} />
								<CardDoubleInfo {...infoDoblePerson[numberInfoDoubleClient].p2} />
							</div>
						</div>
					</>
				)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Conociendo las leyes sabrás como y cuando negar una venta de alcohol, por ejemplo.`}
						callback={() => {
							setNumberInfoDoubleClient(1)
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Conociendo las leyes sabrás como y cuando negar una venta de alcohol, por ejemplo.`}
						callback={() => {
							setNumberInfoDoubleClient(2)
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Conociendo las leyes sabrás como y cuando negar una venta de alcohol, por ejemplo.`}
						callback={() => {
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora conoces los requisitos para realizar una venta responsable."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema7.activities.subtema1
								})
							);
							navigator("/home7/tema7/subtema1/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}


const CardDoubleInfo = ({ title = "", img = "", subtitle = "" }) => {
	return (
		<>
			<div className="w-[209px] h-[239px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
				<div className="bg-red_primary w-full h-[28px] md:h-[40px] rounded-lg flex justify-center items-center">
					<p className="text-white text-[10px] md:text-[16px]">{title}</p>
				</div>
				<div className="h-[calc(100%-28px-50px)] md:h-[calc(100%-40px-100px)] md:py-4 md:px-7">
					<div className="w-full h-full py-3">
						<img className="h-full w-full object-contain" src={img} alt="client" />
					</div>
				</div>
				<div className='w-full h-[50px] md:h-[100px] px-0 md:px-6'>
					<div className='bg-white text-black rounded-[12px] md:rounded-[8px] flex justify-center items-center text-center p-2 md:p-4 overflow-hidden'>
						<span className='text-[8px] md:text-[16px]'>{subtitle}</span>
					</div>
				</div>
			</div>
		</>
	)
}